import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import { Provider } from 'react-redux';
import App from './App';
import 'less/index.css';
import * as serviceWorker from 'registerServiceWorker';
import configureStore from 'configureStore';

const store = configureStore();

function Root() {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
}

ReactModal.setAppElement('#root');
ReactDOM.render(<Root />, document.getElementById('root'));
serviceWorker.unregister();
